<template>
  <div class="changelog-view">
    <EnhancedChangelog />
  </div>
</template>

<script>
import EnhancedChangelog from '../components/changelog/EnhancedChangelog.vue'

export default {
  name: 'ChangeLog',
  components: {
    EnhancedChangelog
  }
}
</script>

<style scoped>
.changelog-view {
  padding: 20px;
  min-height: 100vh;
  background: linear-gradient(135deg, #1e1e1e 0%, #2d2d2d 100%);
}

/* Global styles for enhanced changelog */
@import '../styles/tier-colors.css';
</style>